import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
import { useIsMobile } from './useIsMobile';

// Semantic flags for the results-page experiments, read once from the bag.

export const useResultsPageConfig = () => {
  var _getPremiumEssentials;
  const experiments = (_getPremiumEssentials = getPremiumEssentialsSafe()) == null ? void 0 : _getPremiumEssentials.experiments;
  const isOn = spec => Boolean(experiments == null ? void 0 : experiments[spec]);
  const isMobile = useIsMobile();
  const isV41 = isOn(ExperimentSpecs.ResultsPageOptimizationsV41);
  const isV41Desktop = isV41 && !isMobile;
  return {
    showExactMatchHeadline: isOn(ExperimentSpecs.ResultsPageExactMatchHeadline) && !isV41,
    isV41,
    isV41Desktop,
    isOptimized: isV41 || isMobile
  };
};
//# sourceMappingURL=useResultsPageConfig.js.map